export default [
    {
        path: 'motivo-viagem-procedimento',
        component: () => import(
            '@/views/transporte-paciente/motivo/Index'
        ),
        redirect: 'motivo-viagem-procedimento/list',
        children: [
            {
                name: 'transporte-paciente-motivo-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/motivo/List'
                ),
            },
            {
                name: 'transporte-paciente-motivo-create',
                path: 'create',
                component: () => import(
                    '@/views/transporte-paciente/motivo/Form'
                ),
            },
            {
                name: 'transporte-paciente-motivo-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/transporte-paciente/motivo/Form'
                ),
            },
        ],
    },
]